import { proxy } from "valtio";
import { User } from "../types/user";

type Nullable<T> = T | null;

export const WeddingUsersStore = proxy<{
  eventPlanner: Nullable<User>;
  groom: Nullable<User>;
  bride: Nullable<User>;
  guestManager: Nullable<User>;
}>({
  eventPlanner: null,
  groom: null,
  bride: null,
  guestManager: null,
});
